var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.47499 9.77502C6.65833 9.62502 6.86666 9.54586 7.09999 9.53752C7.33333 9.52919 7.53333 9.60836 7.69999 9.77502L12.025 14.1L16.375 9.75002C16.525 9.60002 16.7292 9.52919 16.9875 9.53752C17.2458 9.54586 17.45 9.62502 17.6 9.77502C17.7833 9.95836 17.8708 10.1625 17.8625 10.3875C17.8542 10.6125 17.7667 10.8084 17.6 10.975L12.625 15.95C12.525 16.0334 12.4292 16.0959 12.3375 16.1375C12.2458 16.1792 12.1417 16.2 12.025 16.2C11.9083 16.2 11.8042 16.1792 11.7125 16.1375C11.6208 16.0959 11.525 16.0334 11.425 15.95L6.47499 11C6.30833 10.8334 6.22916 10.6334 6.23749 10.4C6.24583 10.1667 6.32499 9.95836 6.47499 9.77502Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.0883bacc.svg";
export { ForwardRef as ReactComponent };